@if (form) {
    <div class="flex-column gap">
        <app-warn-float-message>
            <div>
                <span>{{ 'waitingList.offerExists.messages.removeFromWaitingList1st' | translate }}</span>
                <p-chip
                    [label]="$any(item.offer) | formatOfferDuration"
                    [pTooltip]="item.offer?.name || ''"
                    [ngStyle]="{ 'background-color': item.offer?.color || DEFAULT_TAG_COLOR, 'border-radius': '16px', color: (item.offer?.color || DEFAULT_TAG_COLOR) | colorContrast }"
                ></p-chip>
                <span>{{ 'waitingList.offerExists.messages.removeFromWaitingList2nd' | translate }}</span>
            </div>
        </app-warn-float-message>

        <div class="grid-2col input-grid-gaps">
            <app-date-input
                [form]="form"
                id="dateTo"
                [prefix]="prefix"
            ></app-date-input>

            <app-number-input
                [form]="form"
                id="applications"
                [prefix]="prefix"
            ></app-number-input>
        </div>
    </div>
}

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        primaryButtonLabel="common.confirm"
        (primaryClickEvent)="save($event)"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>

<!--<div #dialogFooter class="p-dialog-footer">-->
<!--    <div class="flex gap align-items-center justify-content-end">-->
<!--        <app-button-->
<!--            label="common.no"-->
<!--            severity="secondary"-->
<!--            (clickEvent)="onClick(false)"-->
<!--        ></app-button>-->
<!--        <app-button-->
<!--            label="common.yes"-->
<!--            severity="primary"-->
<!--            (clickEvent)="onClick(true)"-->
<!--        ></app-button>-->
<!--    </div>-->
<!--    &lt;!&ndash;    <app-action-buttons&ndash;&gt;-->
<!--    &lt;!&ndash;        [primaryButtonDisability]="isInvalid(form) || conflictedOffers().toClose.length > 0 || conflictedOffers().notToClose.length > 0"&ndash;&gt;-->
<!--    &lt;!&ndash;        (primaryClickEvent)="save($event)"&ndash;&gt;-->
<!--    &lt;!&ndash;        (secondaryClickEvent)="dialogRef.close()"&ndash;&gt;-->
<!--    &lt;!&ndash;    ></app-action-buttons>&ndash;&gt;-->
<!--</div>-->
